export const mainData = {
  websiteTitle: "Origin Restaurant",
  address: "4 Kilo, behind Ambassador, Ethiopia",
  lang: "eng",
  author: "samtes64",
  authorURL: "mailto:samtes64@gmail.com",
}
